import React, { useEffect } from 'react';
import { Card, Row, Col } from 'antd';
import { useSelector } from 'react-redux';
import { ILoginState } from '@share/store/slices';
import { Link } from 'react-router-dom';
import './style.scss';
import { FormattedMessage, useIntl } from 'react-intl';
import invite_team from "@assets/images/home/invite-team.jpg";
import add_card from "@assets/images/home/add-card.jpg";
import approved_hotels from "@assets/images/home/approved-hotels.jpg";
interface CardProps {
  title: string;
  description: string;
  buttonText: string;
  buttonLink: string;
  imageSrc: string;
}

interface CardCarouselProps {
  Tools: CardProps[];
}

const CardCarousel: React.FC<CardCarouselProps> = ({ Tools }) => {
  const intl = useIntl();

  const toolsData : CardProps[] = [
    {
      title: intl.formatMessage({ id: 'dashboard.tools.invite.title' }),
      description: intl.formatMessage({ id: 'dashboard.tools.invite.description' }),
      buttonText: intl.formatMessage({ id: 'dashboard.tools.invite.button' }),
      buttonLink: '/company-team',
      imageSrc: invite_team,
    },
    {
      title: intl.formatMessage({ id: 'dashboard.tools.payment.title' }),
      description: intl.formatMessage({ id: 'dashboard.tools.payment.description' }),
      buttonText: intl.formatMessage({ id: 'dashboard.tools.payment.button' }),
      buttonLink: '/account-payment',
      imageSrc: add_card,
    },
    {
      title: intl.formatMessage({ id: 'dashboard.tools.approved.title' }),
      description: intl.formatMessage({ id: 'dashboard.tools.approved.description' }),
      buttonText: intl.formatMessage({ id: 'dashboard.tools.approved.button' }),
      buttonLink: '/company-travel',
      imageSrc: approved_hotels,
    },
  ];
  return (
    <div className="site-card-wrapper m-auto toolsCard">
      <div className="header text-center mb-5">
        <h3 className='mb-0'><FormattedMessage id="dashboard.admin.tools.title" /></h3>
        <p className='fs-14'><FormattedMessage id="dashboard.admin.tools.description" /></p>
      </div>
      <Row gutter={16}>
        {toolsData.map((card, index) => (
          <Col xs={24} sm={12} md={12} lg={8} key={index}>
            <CustomCard {...card} />
          </Col>
        ))}
      </Row>
    </div>
  );
};

const CustomCard: React.FC<CardProps> = ({
  title,
  description,
  buttonText,
  buttonLink,
  imageSrc,
}) => {
  const loginStore = useSelector((state: { loginStore: ILoginState }) => state.loginStore);

  return (
    <div className="card custom-card">
      <img src={imageSrc} className="card-img card-img-height" alt={imageSrc} />
      <div className="position-absolute top-100 start-50 translate-middle translate-whiteBox w-100">
        <div className="card-body text-center bg-white shadow  rounded mx-4 p-3">
          <h6 className="card-title mb-1">
            <a href={buttonLink}>{title}</a>
          </h6>
          <small>{description}</small>
          <div className="mt-2 ">
            <Link to={`/${loginStore.account?.name}${buttonLink}`} className="btn btn-sm btn-dark mb-0">
              {buttonText}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardCarousel;
